module.exports = __webpack_public_path__ + "static/media/erro.8442383c.svg";